import { render, staticRenderFns } from "./ImageDetails2.vue?vue&type=template&id=8af4d256"
import script from "./ImageDetails2.vue?vue&type=script&lang=js"
export * from "./ImageDetails2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports